import {Component} from '@angular/core';

@Component({
	selector: 'upm-bb-design-view',
	templateUrl: './bb-design-view.component.html',
	styleUrls: ['./bb-design-view.component.less']
})
export class BbDesignViewComponent{
}
